import ReportsService from "@/modules/reports/ReportsService";
import _ from "lodash";

export default {
  namespaced: true,
  state: {
    reports: [],
    loading: false,
    reportConfigurationModal: {
      show: false,
      report: null,
      source: null
    },
    reportGenerationModal: {
      show: false,
      report: null,
      source: null
    },
  },
  actions: {
    async getReports({commit}) {
      commit('changeLoading', true);
      let response = await ReportsService.getReports({active: true, limit: 200, page: 1});
      commit('changeLoading', false);
      if (response.success) {
        commit('getReports', response.body.results);
      }
      return response;
    },
    showReportConfigurationModal({commit}, {report = {}, source} = {}) {
      commit('showReportConfigurationModal', {report: _.cloneDeep(report), source});
    },
    hideReportConfigurationModal({commit}) {
      commit('hideReportConfigurationModal');
    },
    showReportGenerationModal({commit}, {report = {}, source} = {}) {
      commit('showReportGenerationModal', {report: _.cloneDeep(report), source});
    },
    hideReportGenerationModal({commit}) {
      commit('hideReportGenerationModal');
    },
  },
  mutations: {
    changeLoading: (state, payload) => state.loading = payload,
    getReports: (state, payload) => state.reports = payload,
    showReportConfigurationModal: (state, {report, source}) => {
      state.reportConfigurationModal.show = true;
      state.reportConfigurationModal.report = report;
      state.reportConfigurationModal.source = source;
    },
    hideReportConfigurationModal: state => state.reportConfigurationModal.show = false,
    showReportGenerationModal: (state, {report, source}) => {
      state.reportGenerationModal.show = true;
      state.reportGenerationModal.report = report;
      state.reportGenerationModal.source = source;
    },
    hideReportGenerationModal: state => state.reportGenerationModal.show = false,
  }
}
